/** "bus KCE998Z" — or just the nickname when it already starts with "Bus".
 *  Nicknames are created as "Bus <plate>", so any sentence that says
 *  "on bus {name}" read "on bus Bus KCE998Z" (Gabriel, 2026-08-22, the
 *  Send Announcement modal). One place to get it right. */
export function busPhrase(name: string | null | undefined): string {
  const n = String(name ?? '').trim();
  if (!n) return 'this bus';
  return /^bus\b/i.test(n) ? n : `bus ${n}`;
}
